import AOS from "aos";

document.addEventListener(
  "DOMContentLoaded",
  () => {
    let elements = [
      ".image > img",
      ".companies > ul li",
      ".feature-cards > ul > li",
      ".reasons ul li",
      ".customer-statements > ul > li",
      ".facts-and-figures > ul > li",
    ];

    for (let selector of elements) {
      document.querySelectorAll(selector).forEach((el) => {
        el.dataset["aos"] = "fade-up";
      });
    }

    document.querySelectorAll("details p a[href]").forEach((a) => (a.target = "_blank"));

    AOS.init();
  },
  false
);
